import Card from '@material-ui/core/Card';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Error, Loading, required, SaveContextProvider, SimpleForm, TextInput, Title, useNotify } from 'react-admin';
import { equalNewPassWords } from '../references';
import { json } from '../references.js';

const ResetPassword = (props) => {
  const [fullname, setFullname] = useState('');
  const [error, setError] = useState();
  const [saving, setSaving] = useState();


  const notify = useNotify();
  useEffect(() => {
    setFullname(localStorage.getItem('fullname'));

  }, []);

  const handleSave = useCallback((values) => {
    setSaving(true);
    const url = process.env.REACT_APP_URL + '/user/changeMyPassword';

    fetch(url, {
      method: 'POST',
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({ "oldPassword": values.oldPassword, "newPassword": values.newPassword, "newPassword1": values.newPassword1 })
    }
    )
      .then(json)
      .then(
        (reponse) => {
          setSaving(false);
          if (reponse.status && reponse.status > 310) {
            notify(reponse.errors[0].defaultMessage, 'error');

          } else {
            notify(reponse.message, 'success');
          }

        })
      .catch(function (error) {
        setError(error);
        setSaving(false);
        notify('Request failed', 'warning');
      });
  }, [notify]);

  const saveContext = useMemo(() => ({
    save: handleSave,
    saving
  }), [saving, handleSave]);

  if (saving) return <Loading />;
  if (error) return <Error />;
  return (
    <div style={{ margin: 15 }}>
      <Title title={'Changement de mot de passe - ' + fullname} />

      <Card>
        <SaveContextProvider value={saveContext}>

          <SimpleForm title='Change' submitOnEnter={true} save={(record) => handleSave(record)}>
            <TextInput source="oldPassword" label="Ancienne mot de passe" fullWidth validate={[required()]} />
            <TextInput source="newPassword" label="Nouveau mot de passe" fullWidth validate={[required(), equalNewPassWords]} />
            <TextInput source="newPassword1" label="Encore nouveau mot de passe" fullWidth validate={[required(), equalNewPassWords]} />
          </SimpleForm>
        </SaveContextProvider>
        <legend style={{ color: 'gray', fontSize: 12, margin: 10 }}>
          <i>
            Votre nouveau mot de passe doit contenir au moins une lettre majuscule, un caractère spécial (#,@,!,%,*), un chiffre et doit avoir une taille minimale de 8 caractères.
          </i>
        </legend>
      </Card>

    </div>

  );

}

export default ResetPassword;

//export default RechercheCode;
